import React from 'react'
import '../../App.css'
import { FaCoffee } from 'react-icons/fa'
// import { Link } from 'react-router-dom'
export const ContestItem = (props) => {
  return (
    // <link to="contestDetail">
    <div className=" card1" >
      <img src={props.src} className="card-img-top" alt="mango image" />
      <div className="card-body ">
        <h3 className="card-title">{props.title}</h3>
        <div className="d-flex"> <FaCoffee color='black' className='mt-2 me-2'/><p className='card-item '>{props.li1a}{props.li2a}</p></div>
        <div className="d-flex">    <FaCoffee color='black' className='mt-2 me-2'/> <p className='card-item '>{props.li1d}{props.li2d}</p></div>
        <div className="d-flex"><FaCoffee color='black' className='mt-2 me-2'/><p className='card-item '>{props.li1c}{props.li2c}</p></div>
        <div className="d-flex"><FaCoffee color='black' className='mt-2 me-2'/><p className='card-item '>{props.li1b}{props.li2b}</p></div>

      </div>
    </div>
        // </link>
  )
}
